
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FuseConfigService } from '../../../../../@fuse/services/config.service';
import { Location } from '@angular/common';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: fuseAnimations
})

export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  resetPasswordFormErrors: any;
  hideConfirmPassword = true;
  hideNewPassword = true;
  userCurrentPassword: string;

  constructor(private fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private parseService: ParseService,
    private router: Router,
    private toastr: ToastrService,
    private _location: Location,
    private storageConfiguration: StorageConfiguration
  ) {

    this.userCurrentPassword = this.storageConfiguration.sessionGetItem(this.storageConfiguration.userAuth);
    // Configure the layout
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    this.resetPasswordFormErrors = {
      email: {},
      password: {},
      passwordConfirm: {}
    };

  }


  /* 
  ** ==========================================================
  **   On init
  ** ==========================================================
  */

  ngOnInit(): void {
    let PassReg = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$');
    // MAIL AND PASSWORD VALIDATION
    this.resetPasswordForm = this._formBuilder.group({
      // email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      passwordConfirm: ['', [Validators.required, confirmPassword]]
    });

    this.resetPasswordForm.valueChanges.subscribe(() => {
      let payload1 = {
        password1: this.resetPasswordForm.value.password
      }
      if (PassReg.test(payload1.password1) === true) {
        document.getElementById('divpattern').style.display = 'none';
        this.onResetPasswordFormValuesChanged();
      } else if (payload1.password1.length <= 8) {
        document.getElementById('divpattern').style.display = 'block';
        return;
      } else if (PassReg.test(payload1.password1) === false) {
        document.getElementById('divpattern').style.display = 'block';
        return;
      }
    });
  }

  onResetPasswordFormValuesChanged() {
    for (const field in this.resetPasswordFormErrors) {
      if (!this.resetPasswordFormErrors.hasOwnProperty(field)) {
        continue;
      }
      // Clear previous errors
      this.resetPasswordFormErrors[field] = {};
      // Get the control
      const control = this.resetPasswordForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.resetPasswordFormErrors[field] = control.errors;
      }
    }
  }


  /* 
  ** ==========================================================
  **   Reset Form Validation
  ** ==========================================================
  */

  async onSubmit() {
    let user_id = this.parseService.instance.User.current().id;
    let startend = this.startenddates(new Date());
    let UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let userTimeSheet = new this.parseService.instance.Query(UserTimeSheet);
    userTimeSheet.equalTo('user', { __type: 'Pointer', className: '_User', objectId: user_id });
    userTimeSheet.greaterThan('createdAt', startend[0]);
    userTimeSheet.lessThan('createdAt', startend[1]);
    let timeSheetDetails = await userTimeSheet.find();
    for (let data of timeSheetDetails) {
      if (data.get('currentStatus') == 'work' || data.get('currentStatus') == 'idle') {
        return this.toastr.warning('Please close the Desktop application!!');
      }
    }

    if (!this.resetPasswordForm.valid) return;
    if (this.resetPasswordForm.value.password == this.userCurrentPassword) return this.toastr.warning('Your new password cannot be the same as your current password!!');
    let payload = {
      userName: this.resetPasswordForm.value.email,
      password: this.resetPasswordForm.value.passwordConfirm
    }
    // if (this.resetPasswordForm.value.passwordConfirm == 'SmartWork@123') {
    //   this.toastr.error("Please enter new password");
    // }
    // else {
    let profileDetails = this.parseService.instance.Object.extend("User");
    let query = new this.parseService.instance.Query(profileDetails);
    query.equalTo("objectId", user_id);
    query.find().then(function (results) {
      if (results.length > 0) {
        let twilightDetails = results[0];
        twilightDetails.set('password', payload.password);
        twilightDetails.save({
          success: function (_Tdetails) {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.isloggedIn, 'true');
          },
          error: function (error) {
          }
        }).then(res => {
          this.toastr.success("Password Reset Successfully");
          // this.router.navigate(['/login']);
          window.location.href = `${environment.baseUrl}/#/try`;
        });
      } else {
        alert("No password found for this id");
      }
    }.bind(this)).catch(function (error) {
    });
    // }
  }

  backlocation() {
    this._location.back();
  }
  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

}

function confirmPassword(control: AbstractControl) {
  if (!control.parent || !control) {
    return;
  }
  const password = control.parent.get('password');
  const passwordConfirm = control.parent.get('passwordConfirm');
  if (!password || !passwordConfirm) {
    return;
  }
  if (passwordConfirm.value === '') {
    return;
  }
  if (password.value !== passwordConfirm.value) {
    return {
      passwordsNotMatch: true
    };
  }
}


